import { render, staticRenderFns } from "./WhyPartnerWithUs.vue?vue&type=template&id=183958e3&scoped=true"
import script from "./WhyPartnerWithUs.vue?vue&type=script&lang=js"
export * from "./WhyPartnerWithUs.vue?vue&type=script&lang=js"
import style0 from "./WhyPartnerWithUs.vue?vue&type=style&index=0&id=183958e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183958e3",
  null
  
)

export default component.exports